

import React, { Component } from 'react';
import { Tree, Input, Tooltip, Icon, Modal, message } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';

const TreeNode = Tree.TreeNode;
const Search = Input.Search;


class InvFileCatalog extends Component {
    state = {
        treeData: [],   //目录数据
        simplifyTreeData: [],
        visible: false,
        loading: false,
        expandedKeys: [],
        searchValue: '',
        autoExpandParent: true,
        pathIds: [],  //树节点当前路径id
    }

    show = () => {
        this.setState({
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    submit = () => {
        const { currentPublishStatus, published, publish } = this.props;
        if (currentPublishStatus === 'PENDING_APPROVAL') {
            message.error('访视周期计划发布审批中，不可重复发布！');
        } else {
            Modal.confirm({
                iconType: 'question-circle',
                title: published ? '是否取消发布访视周期计划' : '是否确认发布已配置的访视周期计划',
                content: published ? '取消发布后，访视记录填写页不再显示访视周期计划部分（取消发布不会影响已填写的数据）' : '待领域leader/业务线负责人审批通过后会自动发布',
                onOk: () => {
                    const { pathIds, simplifyTreeData } = this.state;
                    if (pathIds.length == 0) {
                        return message.warning('请选择设计方案文件路径！')
                    };
                    const sendParams = {};
                    (pathIds || []).map((el, index) => {
                        simplifyTreeData.map(data => {
                            const { id, invId, parentId, catalogName } = data;
                            if (id == el) {
                                sendParams[`investigationFileInfos[${index}].investigationId`] = invId;
                                sendParams[`investigationFileInfos[${index}].fileManageId`] = id;
                                sendParams[`investigationFileInfos[${index}].fileName`] = catalogName;
                                sendParams[`investigationFileInfos[${index}].parentId`] = parentId;
                            }
                        })
                    });
                    this.setState({ loading: true });
                    const options = {
                        method: 'POST',
                        url: API_URL.plan.savePublishFileUrl,
                        data: {
                            ...sendParams,
                        },
                        dataType: 'json',
                        doneResult: res => {
                            this.setState({ loading: false });
                            this.hide();
                            publish();
                        },
                        errorResult: () => {
                            this.setState({ loading: false });
                        }
                    };
                    $.sendRequest(options);
                },
            });
        }
    }

    loadData = () => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.invFolder.queryInvCatalogTree,
            data: {
                invId: sessionStorage.invId,
            },
            dataType: 'json',
            doneResult: res => {
                const { catalogs = {} } = res;
                const data = [{ ...catalogs }];
                const expandedKeys = String(catalogs.id);
                const simplifyTreeData = this.flattenList(data);
                this.setState({
                    loading: false,
                    treeData: data,
                    expandedKeys,
                    simplifyTreeData,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    //数组扁平化
    flattenList = list => {
        const result = [];
        // 递归遍历函数
        const traverse = (nodes) => {
            nodes.forEach((node) => {
                result.push({ ...node }); // 浅拷贝节点，避免修改原数据
                if (node.children) {
                    traverse(node.children);
                }
            });
        };
        traverse(list);
        return result;
    }

    onExpand = (expandedKeys) => {
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onSelect = (id) => {
        const { treeData } = this.state;
        const pathIds = this.findNodePath(treeData, id);
        this.setState({ pathIds })
    }

    onChange = (e) => {
        const { simplifyTreeData } = this.state;
        const value = e.target.value;
        const expandedKeys = [];
        simplifyTreeData.map(el => {
            if (el.catalogName.indexOf(value) > -1) {
                expandedKeys.push(String(el.id));
            }
        });
        this.setState({
            expandedKeys,
            searchValue: value,
            autoExpandParent: true,
        });
    }

    setTipTittle = (text) => {
        if (!text) {
            return ''
        }
        const arr = (text || "").split("\n");
        const tipTitle = (
            <div>
                <span style={{ color: 'yellow' }}>注意：自查要点</span><br />
                {arr.map(el => (
                    <span>
                        {el}
                        <br />
                    </span>
                ))}
            </div>
        );
        return tipTitle
    }


    //判断字段是否等于某些值
    booleanEquals = (key, value = []) => {
        return value.some((el) => key === el);
    };

    // 递归查找节点路径
    findNodePath = (treeData, nodeId, path = []) => {
        for (let node of treeData) {
            // 将当前节点 ID 加入路径
            const currentPath = [...path, node.id];

            // 如果找到目标节点，返回路径
            if (node.id === nodeId) {
                return currentPath;
            }

            // 如果有子节点，递归查找
            if (node.children && node.children.length > 0) {
                const foundPath = this.findNodePath(node.children, nodeId, currentPath);
                if (foundPath) {
                    return foundPath;
                }
            }
        }
        return null;
    };

    render() {
        const {
            treeData,
            loading,
            searchValue = '',
            expandedKeys,
            autoExpandParent,
            visible,
        } = this.state;
        const loop = data => (data || []).map(item => {
            const { id, catalogName, catalogDesc, catalogIndex } = item;
            const isSearch = searchValue ? catalogName.includes(searchValue) : false;
            const fontContent = <Tooltip placement="right" title={catalogName}>
                <span className='ellipsis'>{catalogName}</span>
            </Tooltip>;

            const tipTitle = this.setTipTittle(catalogDesc);

            const title =
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: catalogIndex == 1 ? -7 : 2,
                        backgroundColor: isSearch ? '#cfe8fc' : undefined,
                    }}
                >
                    {
                        catalogIndex == 1 ? <span style={{ display: 'flex', alignItems: 'center' }}>
                            <i className="icon iconfont" style={{ marginRight: 3, fontSize: '22px', color: '#5959df' }}>&#xe6cf;</i>
                            {fontContent}
                        </span> : <span
                            style={{ display: 'flex', alignItems: 'center' }}
                            onClick={() => this.onSelect(id, catalogName)}
                        >
                            <Icon type="folder-open" style={{ marginRight: 4, fontSize: 18, color: '#5959df' }} />
                            {fontContent}
                        </span>
                    }
                    {
                        !!tipTitle && <Tooltip placement="right" overlayClassName="head_tip" title={tipTitle}>
                            <a><Icon style={{ fontSize: 14, marginLeft: 5 }} type="info-circle" /></a>
                        </Tooltip>
                    }

                </div>;
            return (
                <TreeNode key={String(item.id)} title={title}>
                    {loop(item.children)}
                </TreeNode>
            );
        });

        return (
            <Modal
                title="设计方案"
                visible={visible}
                onCancel={this.hide}
                onOk={this.submit}
                maskClosable={false}
                confirmLoading={loading}
                width="420px"
            >
                <div>
                    <Search
                        style={{ marginBottom: 8, marginLeft: 5, width: 280 }}
                        placeholder="请输入"
                        onChange={this.onChange}
                    />
                    <Tree
                        showLine
                        onExpand={this.onExpand}
                        expandedKeys={expandedKeys}
                        autoExpandParent={autoExpandParent}
                    >
                        {loop(treeData)}
                    </Tree>
                </div>
            </Modal>

        )
    }
}

export default InvFileCatalog





// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/InvFileCatalog.js